import { FeaturesEnum } from './models/enums/features.enum';
import { TicketsEnum } from './models/enums/permissions/tickets.enum';
import { LogTicketEnum } from './models/enums/permissions/log-ticket.enum';
import { TicketQueueEnum } from './models/enums/permissions/ticket-queue.enum';
import { TestCasesEnum } from './models/enums/permissions/test-cases.enum';
import {
    CarrierDashboardEnum,
    ConfirmLpsRoutesEnum,
    EngineeringDashboardEnum,
    HomeEnum,
    LookupsManagementEnum,
    PremiumCheckListEnum,
    PtaConfigurationEnum,
    PtaExistingRequestsEnum,
    PtaNewRequestEnum,
    SignOffContactsEnum,
    SupplierDashboardEnum,
    UpdateLpsRoutesEnum,
    UserManagementEnum,
    RolePermissionsEnum,
} from './models/enums/permissions';

export type PermissionEnumType =
    | typeof HomeEnum
    | typeof PtaExistingRequestsEnum
    | typeof PtaNewRequestEnum
    | typeof PremiumCheckListEnum
    | typeof UpdateLpsRoutesEnum
    | typeof ConfirmLpsRoutesEnum
    | typeof SupplierDashboardEnum
    | typeof CarrierDashboardEnum
    | typeof EngineeringDashboardEnum
    | typeof UserManagementEnum
    | typeof LookupsManagementEnum
    | typeof PtaConfigurationEnum
    | typeof SignOffContactsEnum
    | typeof RolePermissionsEnum
    | typeof TicketsEnum
    | typeof TestCasesEnum
    | typeof LogTicketEnum
    | typeof TicketQueueEnum;


export type PermissionEnumKey = keyof PermissionEnumType;

export const FeaturePermissions: Record<FeaturesEnum, PermissionEnumType> = {
    [FeaturesEnum.HOME]: HomeEnum,
    [FeaturesEnum.PTA_EXISTING_REQUESTS]: PtaExistingRequestsEnum,
    [FeaturesEnum.PTA_NEW_REQUEST]: PtaNewRequestEnum,
    [FeaturesEnum.PREMIUM_CHECKLIST]: PremiumCheckListEnum,
    [FeaturesEnum.UPDATE_LPS_ROUTES]: UpdateLpsRoutesEnum,
    [FeaturesEnum.CONFIRM_LPS_ROUTES]: ConfirmLpsRoutesEnum,
    [FeaturesEnum.SUPPLIER_DASHBOARD]: SupplierDashboardEnum,
    [FeaturesEnum.CARRIER_DASHBOARD]: CarrierDashboardEnum,
    [FeaturesEnum.ENGINEERING_DASHBOARD]: EngineeringDashboardEnum,
    [FeaturesEnum.USER_MANAGEMENT]: UserManagementEnum,
    [FeaturesEnum.LOOKUPS_MANAGEMENT]: LookupsManagementEnum,
    [FeaturesEnum.PTA_CONFIG]: PtaConfigurationEnum,
    [FeaturesEnum.SIGNOFF_CONTACTS]: SignOffContactsEnum,
    [FeaturesEnum.ROLE_PERMISSIONS]: RolePermissionsEnum,
    [FeaturesEnum.TICKETS_DASHBOARD]: TicketsEnum,
    [FeaturesEnum.TEST_CASES]: TestCasesEnum,
    [FeaturesEnum.LOG_TICKET]: LogTicketEnum,
    [FeaturesEnum.TICKET_QUEUE]: TicketQueueEnum,
} 